import { useNavigate } from "react-router-dom";

import { FieldName, FieldValueWithBorder, Heading, Row, Table } from "components/LayoutParts";
import Loading from "components/Loading";
import PaginationForGraphql from "components/PaginationForGraphql";

const companyTableColumn = [
  {
    label: "会社名・支店/支社名",
    flex: 2,
  },
  {
    label: "住所",
    flex: 2,
  },
  {
    label: "電話番号",
    flex: 1,
  },
  {
    label: "FAX番号",
    flex: 1,
  },
  {
    label: "営業時間",
    flex: 1,
  },
] as const;

const DataTable = ({
  companyList,
  totalPages,
  pageIndex,
  setPageIndex,
  pageInfo,
  setPagination,
}: {
  companyList?: SyncPortCompany[];
  totalPages: number;
  pageIndex: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
  pageInfo?: GraphqlPageInfo;
  setPagination: React.Dispatch<React.SetStateAction<GraphqlPageOption>>;
}) => {
  const navigate = useNavigate();
  const onClickRow = (id: string) => navigate(`/sync_port/company/${id}/info`);

  return (
    <>
      <Table>
        <Heading>
          {companyTableColumn.map((column) => (
            <FieldName
              key={column.label}
              flex={column.flex}
              lastColumn={column.label === companyTableColumn[companyTableColumn.length - 1].label}
            >
              {column.label}
            </FieldName>
          ))}
        </Heading>
        {companyList == null ? (
          <Loading />
        ) : companyList.length > 0 ? (
          companyList.map((company) => (
            <Row key={company.id} onClick={() => onClickRow(company.id)}>
              <FieldValueWithBorder
                flex={companyTableColumn[0].flex}
              >{`${company.name} ${company.branchName}`}</FieldValueWithBorder>
              <FieldValueWithBorder flex={companyTableColumn[1].flex}>{company.address}</FieldValueWithBorder>
              <FieldValueWithBorder flex={companyTableColumn[2].flex}>{company.phoneNumber}</FieldValueWithBorder>
              <FieldValueWithBorder flex={companyTableColumn[3].flex}>{company.faxNumber}</FieldValueWithBorder>
              <FieldValueWithBorder flex={companyTableColumn[4].flex} lastColumn>
                {company.openingTime != "" ? `${company.openingTime} 〜 ${company.closingTime}` : ""}
              </FieldValueWithBorder>
            </Row>
          ))
        ) : (
          <p>該当する会社が見つかりませんでした</p>
        )}
      </Table>
      <PaginationForGraphql
        totalPageCount={totalPages}
        currentPageNumber={pageIndex}
        setCurrentPageNumber={setPageIndex}
        setPagination={setPagination}
        startCursor={pageInfo?.startCursor ?? ""}
        endCursor={pageInfo?.endCursor ?? ""}
        hasNextPage={pageInfo?.hasNextPage ?? false}
        hasPreviousPage={pageInfo?.hasPreviousPage ?? false}
      />
    </>
  );
};

export default DataTable;
